var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id)?_c('div',[_c('div',{staticClass:"mt-4 mb-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('DataTable',{ref:"datatableEchange",attrs:{"id":_vm.id},on:{"onSelect":_vm.onSelectRows}})],1)])])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }